export default (model) => ({
  subTitle: "Change Shipping Location Status...",
  title: `${model.id} | ${model.name}`,
  actions: {
    Approve: {
      body: "Location will be activated",
      icon: "thumbs-up",
      status: "Active",
    },
    Reject: {
      body: "Location will be archived",
      icon: "thumbs-down",
      status: "Deleted",
    },
    Cancel: {
      body: "Location will stay in pending status",
      icon: "times-circle-o",
      status: "Pending",
    },
  },
  size: "md",
});
